import { render } from "./ResponseChartsDashboard.vue?vue&type=template&id=23dae2d2"
import script from "./ResponseChartsDashboard.vue?vue&type=script&lang=js"
export * from "./ResponseChartsDashboard.vue?vue&type=script&lang=js"

import "./ResponseChartsDashboard.vue?vue&type=style&index=0&id=23dae2d2&lang=scss"
script.render = render

export default script